/**
 * a simple mockable timestamp function
 */
export default function timestamp() {
  return new Date().toISOString();
}
